<template>
	<div class="btn-group" data-toggle="buttons">
		<button
			class="btn btn-sm"
			@click="$emit('input', 'novas')"
			:class="{ 'btn-success': value == 'novas' }"
		>
			Novas
		</button>
		<button
			class="btn btn-sm"
			@click="$emit('input', 'finalizadas')"
			:class="{ 'btn-primary': value == 'finalizadas' }"
		>
			Finalizadas
		</button>
		<button
			class="btn btn-sm"
			@click="$emit('input', 'atraso')"
			:class="{ 'btn-danger': value == 'atraso' }"
		>
			Atrasadas
		</button>
	</div>
</template>
<script>
	export default {
		props: ['value'],
	};
</script>



// WEBPACK FOOTER //
// src/components/dashboard/components/btn-status.vue